



















































































import { Component, Vue } from 'vue-property-decorator';
import UpdateProofOfAddressChooseYourDocumentsViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-proof-of-address/update-proof-of-address-choose-your-documents-view-model';

@Component({ name: 'UpdateProofOfAddressChooseYourDocuments' })
export default class UpdateProofOfAddressChooseYourDocuments extends Vue {
  update_address_choose_documents_view_model = Vue.observable(
    new UpdateProofOfAddressChooseYourDocumentsViewModel(this),
  );

  async mounted() {
    await this.update_address_choose_documents_view_model.initialize();
  }
}
